import * as React from 'react';

import ParameterFieldBase, { IParameterFieldBaseOptions } from '../../../_common/platform/ts/ParameterFieldBase';
import SelectField from '../../../_common/platform/tsx/SelectField';
import { TitlePositionType } from '../ts/Interfaces';
import { ParameterField } from './ParameterField';


export const TITLE_POSITION_DEFAULT_VALUE = 'before';
export const TITLE_POSITION_TITLE = 'Label Position';

export interface ITitlePositionSelectOptions extends IParameterFieldBaseOptions {
    showPlaceholderAsTitle?: boolean;
}

export function TitlePositionSelectComponent(props: {
    value?: TitlePositionType;
    disabled?: boolean;
    showPlaceholderAsTitle?: boolean;
    options?: ITitlePositionSelectOptions;

    onChange?(value: TitlePositionType): void;
}) {
    let value = props.value;

    if (value == null) {
        value = TITLE_POSITION_DEFAULT_VALUE;
    }

    let values = ['before', 'above', 'placeholder', 'noTitle'];

    if (props.showPlaceholderAsTitle || props.options?.showPlaceholderAsTitle) {
        values.splice(3, 0, 'placeholderAsTitle');
    }

    const display = values.map(value => {
        if (value === 'before') {
            return 'before';
        }
        else if (value === 'above') {
            return 'above';
        }
        else if (value === 'placeholder') {
            return 'placeholder';
        }
        else if (value === 'placeholderAsTitle') {
            return 'show title only';
        }
        else if (value === 'noTitle') {
            return 'no title';
        }
        else {
            console.log('TitlePositionSelectComponent -> Not supported type: ' + value);
            return null;
        }
    });

    return (
        <SelectField
            value={ value }
            disabled={ props.disabled }
            options={ {
                values: values,
                display: display
            } }
            onChange={ props.onChange }
        />
    );
}

export class TitlePositionSelect extends ParameterFieldBase<IParameterFieldBaseOptions> {
    public static defaultValidators = [];
    public static EditComponent = TitlePositionSelectComponent;

    constructor(
        glob,
        title: string = TITLE_POSITION_TITLE,
        defaultVal = TITLE_POSITION_DEFAULT_VALUE,
        options?: ITitlePositionSelectOptions
    ) {
        super(glob, title, TitlePositionSelect.defaultValidators, [], defaultVal, options);
    }
}

export function TitlePositionField(props: {
    value?: TitlePositionType;
    defaultValue?: TitlePositionType;

    onClear?(): void;
    onChange?(value: TitlePositionType): void;
}) {
    const defaultValue = props.defaultValue || TITLE_POSITION_DEFAULT_VALUE;

    return (
        <ParameterField
            title={ TITLE_POSITION_TITLE }
            clearable={ true }
            showInheritedIcon={ props.value == null }
            defaultValue={ defaultValue }
            onClear={ props.onClear }
        >
            <TitlePositionSelectComponent
                value={ props.value || defaultValue }
                onChange={ props.onChange }
            />
        </ParameterField>
    );
}